<template>

  <div>

    <v-alert outlined type="info" v-if="!speedPreference">
      <p>In order for us to recommend a minimum speed, we need more info from you.</p>
      <v-btn small depressed to="/wizard">Start At Beginning</v-btn>
      or select options to the left.
    </v-alert>

    <v-sheet class="mb-2" color="primary white--text">

      <v-container fluid grid-list-xl>

        <v-layout align-center wrap>

          <v-flex shrink>
            <v-icon x-large color="info">mdi-star-circle</v-icon>
          </v-flex>

          <v-flex xs10 sm5>
            <div class="pa-3 title">
              Based on your preferences, we recommend an Internet connection of at least:
            </div>
          </v-flex>

          <v-flex grow>
            <v-card color="info white--text" v-if="speedPreference"
                    class="text-center ma-0 pa-3">
              <div class="font-weight-bold">Recommended</div>
              <h3 class="display-1 my-0 py-0 yellow--text">
                {{$helpers.formatSpeed(speedPreference)}}
                <v-icon color="yellow" x-large v-if="speedPreference > 500">mdi-speedometer</v-icon>
                <v-icon color="yellow" x-large v-else-if="speedPreference >= 100">
                  mdi-speedometer-medium
                </v-icon>
                <v-icon color="yellow" x-large v-else>mdi-speedometer-slow</v-icon>
              </h3>
            </v-card>
          </v-flex>

        </v-layout>

      </v-container>

    </v-sheet>

    <SpeedCalcDescription class="mb-2"
                          :preferences="preferences"
                          :speed-preference="speedPreference"
    ></SpeedCalcDescription>

    <v-card>

      <v-card-text>

        <div class="d-flex align-center">
          <h1 class="headline info--text">
            <v-icon large left color="primary">mdi-format-list-checks</v-icon>
            Service Offerings
          </h1>

<!--          <v-spacer></v-spacer>-->

          <v-chip class="ml-3" small label>{{filteredServiceAreas.length}} results</v-chip>
        </div>

      </v-card-text>

      <v-card-text>

        <ServiceAreasTable
          :items="filteredServiceAreas"
          :custom-headers="customHeaders"
          :blacklist="['properties.County']"
          :sort-by="['properties.Speeds_mbps']"
          :sort-desc="[true]"
          :show-selections="false"
          @row-clicked="viewProvider"
        >

        </ServiceAreasTable>

        <v-alert v-if="preferences.coordinates" outlined dense class="mt-2 font-small"
                 icon="mdi-alert-outline">
          <div class="d-flex align-center">
            Remember that you are filtering the data by the coordinates of the location you selected
            using the map.
            <v-spacer></v-spacer>
            <v-btn small outlined @click="clearCoordinates">
              Clear Coordinates
            </v-btn>
          </div>
        </v-alert>

      </v-card-text>

    </v-card>

  </div>

</template>

<script>
import ServiceAreasTable from '../components/tables/ServiceAreasTable';
import SpeedCalcDescription from '@/components/wizard/SpeedCalcDescription';

export default {

  name: 'WizardOfferings',

  components: { ServiceAreasTable, SpeedCalcDescription, },

  data() {
    return {
      tab: 1,
      dialogSpeedDesc: false,
      customHeaders: [
        {
          index: 0,
          value: 'isRecommended',
          text: 'Recommended',
          sortable: false,
          align: 'center',
        },
      ],
    };
  },

  mounted() {
  },

  computed: {

    preferences() {
      return this.$store.state.wizard.preferences;
    },

    speedPreference() {
      return this.$store.getters.speedPreference;
    },

    filteredServiceAreas() {
      return this.$store.getters.filteredServiceAreas;
    },

  },

  methods: {
    viewProvider(row) {

      this.$router.push({
        name: 'provider-detail',
        params: {
          id: row.properties.ProviderID,
        },
        query: {
          referrer: this.$route.name,
          service: row.id,
          drawer: true,
        },
      });

    },

    clearCoordinates() {
      this.$nextTick(() => {
        this.$store.dispatch('clearPreferencesByKey', 'coordinates');
      });
    },

  },

};

</script>
